export const myPage_en = {
  'edit_profile' : 'Edit profile',
  'walks' : 'Walks',
  'messages' : 'Messages',
  'contacts' : 'Contacts',
  'current_week' : 'Current week',
  'organiser' : 'Organiser',
  'not_booked' : 'Not booked',
  'active_conversations' : 'Active conversations',
  'archived_conversations' : 'Archived conversations',
  'friends' : 'Friends',
  'add_friends_with_email' : 'Add friends',
  'search_email' : 'Or search with email',
  'search_person_button' : 'Search',
  'search_result' : 'Search result',
  'send_friendrequest_to' : 'Send friend request to ',
  'go_to' : 'Go to',
  'go_to_profile' : 'profile',
  'search_person_name' : 'Search with first name',

  'no_email_error' : 'Please enter an email address to search',
  'cannot_find_email_error' : 'Could not find ',
  'cannot_send_self' : 'You cannot send a friend request to yourself.',
  'sent_confirmation_header' : 'Sent',
  'sent_confirmation_message' : 'Friend request is sent to',
  'add_more_friends' : 'Add more',

  'calendar' : 'Calendar',

  'available_walks' : 'Available walks',
  'share_profile' : 'Share the profile',
  'share_your_profile' : 'Share your profile',

  'settings' : 'Settings',
  'account_settings' : 'Account settings',
  'handle_blocked' : 'Handle blocked',
  'send_feedback' : 'Send feedback',
  'upgrade_to_pro' : 'Upgrade to PRO',

  'feedback' : 'Feedback',
  'send_feedback_message' : 'We welcome all questions and suggestions, even if we will not respond to everything, we listen and take it with us as we continue to develop and improve upon Walking Talking.',
  'feedback_placeholder' : 'Enter your feedback here',
  'feedback_GDPR' : 'I consent to Walking Talking contacting me with any questions regarding my feedback.',

  'change_saved' : 'The changes were saved',
  'something_went_wrong' : 'Something went wrong',
  'upgrade_WT_PRO' : 'Upgrade your account to Walking Talking PRO now',

  'archive_chat_with' : 'Archive the chat with ',
  'activate_chat_with' : 'Activate the chat with ',
  'has_sent_friendrequest' : ' has sent a friend request. Do you want to:',
  'walk_suggestion' : 'Walk suggestion',
  'has_booked' : ' has booked the walk:',
  'booked_confirmation' : 'The walk has been booked',
  'cancel_confirmation' : 'The walk has been canceled',
  'conversation_archived' : 'The conversation is archived',

  'change_language_error' : 'Could not change the language, please try again or contact Walking Talking if the issues persists.`',
  'biography_placeholder' : 'Write something short',

  'feedback_confirmation' : 'Thank you for your feedback!',
  'owner_contacts' : "'s contacts",
  'owner_calendar' : "'s calendar",
  'send_message' : 'Chat',

  'invited' : 'Invited',
  'guest' : 'Guest',
  'not_public' : 'Not public',

  'no_walks_today' : 'No walks this day',
  'find_friends' : 'Find friends',
  'suggestion_sent' : 'The walk suggestion has been sent',
  'persons_found' : 'persons found',
  'become_friend' : 'Send friend request',
  'current_walk' : 'Current walk',
  'view_walks' : 'View walks',
  'track_walks' : 'Keep track of your past and upcoming walks',
  'statistic' : 'Statistic',
  'statistic_info' : 'Challenges, Statistic, Daily steps and goals',
  'view_statistic' : 'View statistic',
  'stepchallenges' : 'Step-challenges',
  'manage_friends' : 'Find, manage and make new friends',
  'view_friends' : 'View friends',
  'find_new_friends' : 'Find new friends',
  'friends_info' : 'View, connect and find walks in your networks',
  'find_network' : 'Find networks',

}